var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.06641 7.10938C4.06641 5.98757 4.97585 5.07812 6.09766 5.07812H3.05078C1.92897 5.07812 1.01953 5.98757 1.01953 7.10938C1.01953 8.23118 1.92897 9.14062 3.05078 9.14062H6.09766C4.97585 9.14062 4.06641 8.23118 4.06641 7.10938Z",
    fill: "url(#paint0_linear_1058_310)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.545 13.2031L17.254 23.2057C17.1296 24.2083 16.2746 24.9844 15.2383 24.9844H7.11328C6.07699 24.9844 5.22193 24.2083 5.09757 23.2057L3.30271 9.14062M7.11328 5.07812V3.04688C7.11328 1.92507 8.02272 1.01562 9.14453 1.01562H13.207C14.3288 1.01562 15.2383 1.92507 15.2383 3.04688V5.07812M19.3008 9.14062H3.05078C1.92897 9.14062 1.01953 8.23118 1.01953 7.10938C1.01953 5.98757 1.92897 5.07812 3.05078 5.07812H19.3008C20.4226 5.07812 21.332 5.98757 21.332 7.10938C21.332 8.23118 20.4226 9.14062 19.3008 9.14062Z",
    stroke: "url(#paint1_linear_1058_310)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.207 13.2031V20.9219M9.14453 20.9219V13.2031",
    stroke: "black",
    strokeWidth: 2.03125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1058_310",
    x1: 1.01953,
    y1: 5.07812,
    x2: 4.0662,
    y2: 10.3211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1058_310",
    x1: 1.38294,
    y1: -1.67943,
    x2: 28.4383,
    y2: 19.8201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGradient);
export default __webpack_public_path__ + "static/media/deleteIconGradient.7295169b13f275c1d96a5f8248da279c.svg";
export { ForwardRef as ReactComponent };